import '../helpers/debugger.js';
import h from '../helpers/debugger.js';
import { setEnvironment } from '../config/server.js';
import Urlify from '../helpers/urlify.js';
import config from '../config/index.js';
import { get } from '../helpers/user.js';

import { startLiveReload } from '../helpers/livereload.js';
if (global.env == "staging") setEnvironment("rasmus.fyi");
window.h = h;
// import { login} from '../login/Login.js';
function FormHandler() {
	var signedInUser;
	var form = { // create some kind of listener that runs everytime this object is changed
	}
	var urlify;
	var server = config.server;
	const getUser = async (source) => {
	//h.log("signed in user",typeof signedInUser, signedInUser, "from source",source);
		if (typeof signedInUser != "undefined") {
			return signedInUser;
		} else {
			signedInUser = await get();
			console.log("found user",signedInUser);
			return signedInUser;
		}
	}
	var handleTimeout;
	const updateHandle = (event) => {
	    clearTimeout(handleTimeout);
	    var text = event.target.value;
	    form.handleOK=false;
	    form.handle = urlify(text);
	    event.target.value=form.handle;
	    form.handleTriggered++;
	    document.querySelector(".url").innerHTML=server.host+"/"+form.handle;
	    h.log("handle",text);
	    handleTimeout = setTimeout(checkAvailability,500)
	}
	const updateName = (event) => {
	    form.display_nameTriggered++;
	    var text = event.target.value;
	    h.log("name",text);
	    form.display_name=text;
	    validateForm();
	}

	const checkAvailability = async (e) => {
		console.log("signed in user",signedInUser);
	    let handle = await checkIfHandleAvailable(form.handle, signedInUser.id || signedInUser.social_id);
	    form.handleOK=handle.available;
	    h.log("handle available",handle.available);
		if (!handle.available) {
			document.querySelector("div.url").classList.add("notAvailable");
			document.querySelector("button.primary").setAttribute("disabled",true);
		} else {
			document.querySelector("div.url").classList.remove("notAvailable");
			document.querySelector("button.border").removeAttribute("disabled");
		}
	    validateForm();
	}
	const keydownDisableHandler = (e) => {
		document.querySelector("button.border").setAttribute("disabled",true);
	}
	const submit = async () => {
		console.log("submit");
	//h.log(form.handle, form.display_name, signedInUser.id || signedInUser.social_id);
	    let save = await saveSettings(form.handle, form.display_name, signedInUser.social_id || signedInUser.id);
	    console.log("submitted",save);

	    if (save.completed) {
			try {
				console.log("step3");
				window.ReactNativeWebView.postMessage("step3");
			} catch(e) {
				window.postMessage("step3");
			}
			document.location.href='/onboarding-step-3';
		//h.log("save completed",save)
			document.querySelector(".error").innerHTML = "";
	    } else {
	        document.querySelector(".error").innerHTML = "Couldn't save to server";
		}
		
	}
	const validateForm = () => {
	    var validates = true;
	    if (form.display_name.length==0 || form.handle.length==0 || !form.handleOK) {
	        validates = false;
	    }
	    var message = "";

	    if (!form.handleOK) {

	        validates = false;
	    }
	    if (validates) {
	        message = "";
	    }
	    if (!validates) {
	        document.querySelector("button#submit").setAttribute("disabled",true);
	    } else {
	        document.querySelector("button#submit").removeAttribute("disabled");
	    }
	    document.querySelector(".error").innerHTML = message;
	    return validates;
	    //fix this for both fields
	}
	const checkIfHandleAvailable = async (handle, spotifyID) => {
	    var d = new Date();
	    var url= 'https://'+config.server.subDomain+'.'+config.server.host+'/check_handle?timestamp='+d.getTime();
	    h.log("fetching url",url);
	    try {
	        let response = await fetch(url, {
	            method:'POST',
	            headers: {
	                Accept: 'application/json',
	                'Content-Type': 'application/json',
	            },
	            timeout: 2000,
	            compress: false,
				credentials:'include',
	            body:JSON.stringify({ handle: handle, spotifyID: spotifyID})
	        });
	        let responseJson = await response.json();
	        return responseJson;
	    } catch (error) {
	        h.log("error",error);
	        return null;
	    }
	}
	const saveSettings = async(handle, display_name, spotifyID) => {
	    var d = new Date();
	    var url= 'https://'+config.server.subDomain+'.'+config.server.host+'/create_account?timestamp='+d.getTime();
	    h.log("fetching url",url);

	    signedInUser.handle = handle;
	    signedInUser.display_name = display_name;
	    h.log("updated signed in user object",signedInUser);
	    try {
	        let response = await fetch(url, {
	            method:'POST',
	            headers: {
	                Accept: 'application/json',
	                'Content-Type': 'application/json',
	            },
	            timeout: 2000,
	            compress: false,
				credentials:'include',
	            body:JSON.stringify(signedInUser)
	        });
	        h.log("response",response);
	        let responseJson = await response.json();
	        return responseJson;
	    } catch (error) {
	        h.log("error",error);
	        return null;
	    }
	}
	return {
		Init: async function() {
			var urlifier = new Urlify();
			urlify = urlifier.run;
			await getUser("init function");
		//h.log(signedInUser);
			form = {
				handle:'',
			    handleOK:false,
			    message:'',
			    display_name:signedInUser.displayName,
			    display_nameTriggered:0,
			    handleTriggered:0
			}
		    document.querySelector("#handle").addEventListener("blur",checkAvailability);
		    document.querySelector("#handle").addEventListener("keyup",updateHandle);
			document.querySelector("#handle").addEventListener("keydown",keydownDisableHandler);
		    document.querySelector("#display_name").addEventListener("keyup",updateName);
		    document.querySelector("form").addEventListener("submit", function(e) {
		        var validates = validateForm();
		        if (validates) submit();
		        e.preventDefault();
		        return false;
			});
		}
	}
}

const addCssResizeScale = () => {
	const scale = window.innerWidth / 2560;
	document.documentElement.style.setProperty('--scale_factor', scale);
}

if (document.body.classList.contains("step2")) {
	var myForm = new FormHandler();
	myForm.Init();
} else {
	addCssResizeScale();
}
if (navigator.userAgent.indexOf('Chrome') != -1) {
	document.documentElement.classList.add("chrome");
}
// if (document.body.classList.contains("login")) login();